import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './Legal.css';

const Legal = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Legal Services | Digi Network" 
                description="Learn more about our Legal services to grow your business online with Digi Network." 
                canonical="/industries/legal/legal" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Legal Industry</div>
                        <h1>Digital Marketing for Law Firms</h1>
                        <p>Build authority, attract qualified clients, and grow your law practice with ethical digital marketing strategies designed for the legal industry. We understand the unique challenges law firms face in today's competitive legal market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Legal Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>Legal Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for law firms</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Legal SEO</h3>
                            <p>Rank for practice area keywords, local searches, and build authority in your legal specialty. Our legal SEO strategies help law firms dominate search results for relevant practice areas and local searches.</p>
                            <ul>
                                <li>Local SEO for law firms</li>
                                <li>Practice area optimization</li>
                                <li>Legal content marketing</li>
                                <li>Google My Business for lawyers</li>
                                <li>Legal directory listings</li>
                                <li>Case study optimization</li>
                            </ul>
                            <Link to="/industries/legal/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Legal Paid Ads</h3>
                            <p>Generate qualified leads with compliant advertising campaigns that attract potential clients. Our targeted ad campaigns comply with bar advertising rules while maximizing lead generation.</p>
                            <ul>
                                <li>Google Ads for law firms</li>
                                <li>Facebook & LinkedIn advertising</li>
                                <li>Bar-compliant landing pages</li>
                                <li>Lead generation campaigns</li>
                                <li>Retargeting strategies</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/legal/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Legal Website Design</h3>
                            <p>Professional law firm websites that build trust, showcase expertise, and convert visitors into clients. Our legal websites are designed to present your firm as authoritative and trustworthy.</p>
                            <ul>
                                <li>Attorney website design</li>
                                <li>Case study showcases</li>
                                <li>Client portal integration</li>
                                <li>Mobile-responsive design</li>
                                <li>Testimonial sections</li>
                                <li>Practice area pages</li>
                            </ul>
                            <Link to="/industries/legal/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Legal Email Marketing</h3>
                            <p>Nurture leads with educational content, case updates, and automated follow-up sequences. Build lasting relationships with potential clients through strategic email communication that provides value.</p>
                            <ul>
                                <li>Legal newsletter campaigns</li>
                                <li>Lead nurturing sequences</li>
                                <li>Client communication automation</li>
                                <li>Educational content delivery</li>
                                <li>Case update emails</li>
                                <li>Referral program campaigns</li>
                            </ul>
                            <Link to="/industries/legal/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Legal CRM & Automation</h3>
                            <p>Manage leads, automate follow-ups, and streamline client intake with GoHighLevel for law firms. Automate your lead management and client intake workflows to close more cases.</p>
                            <ul>
                                <li>Lead intake automation</li>
                                <li>Client relationship management</li>
                                <li>Automated follow-up sequences</li>
                                <li>Case management integration</li>
                                <li>Client communication tracking</li>
                                <li>Referral tracking</li>
                            </ul>
                            <Link to="/industries/legal/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title"> Our Legal Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for law firms</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Practice Analysis</h3>
                            <p>We analyze your law firm, practice areas, and competitive landscape to understand your unique positioning. Our team conducts comprehensive audits of your current online presence and marketing performance.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Compliance-First Strategy</h3>
                            <p>We develop a customized marketing strategy that complies with state bar advertising rules and ethical guidelines. Every tactic is designed to maintain compliance while maximizing lead generation.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Authority Building</h3>
                            <p>We implement strategies to build your firm's authority and credibility in your practice areas. From content marketing to thought leadership, we position your firm as the go-to expert.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Lead Generation & Conversion</h3>
                            <p>We generate qualified leads and nurture them through automated follow-up sequences. Our CRM system helps you track every lead and convert more prospects into clients.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Legal Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why Law Firms Choose Digi Network</h2>
                    <p className="why-intro">Trusted by legal professionals across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Bar Compliance</h3>
                            <p>All our marketing strategies comply with state bar advertising rules and ethical guidelines. We understand the strict regulations governing legal marketing and ensure every campaign meets these standards.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Legal Industry Expertise</h3>
                            <p>We understand the legal market and create campaigns that speak to potential clients effectively. Our team has extensive experience working with law firms across various practice areas.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Qualified Lead Generation</h3>
                            <p>We focus on attracting serious, qualified leads who are ready to hire legal representation. Our strategies target people actively seeking legal services, not just browsing.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped law firms generate 200+ qualified leads per month through targeted marketing. Our data-driven approach delivers measurable results that directly impact your caseload.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Law Firms</h2>
                    <p className="section-intro">How our marketing services help you grow your law practice</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Qualified Leads</h3>
                            <p>Generate a steady stream of qualified leads who are actively seeking legal representation. Our targeted campaigns reach people at the right time in their legal journey.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Stronger Online Authority</h3>
                            <p>Build credibility and authority in your practice areas through content marketing and thought leadership. When potential clients search for legal services, they'll find your firm first.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Client Relationships</h3>
                            <p>Automate follow-ups and nurture relationships with automated email campaigns. Keep in touch with past clients and turn them into repeat customers and referrals.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Increased Case Intake</h3>
                            <p>Attract more clients through targeted marketing campaigns that showcase your expertise and track record. Build trust with people looking for legal representation.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Faster Case Conversion</h3>
                            <p>Streamline your intake process with automated lead management and follow-up systems. Convert leads into clients faster with organized communication and tracking.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many law firms still rely on outdated marketing methods like Yellow Pages ads.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Legal Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Grow Your Law Practice?</h2>
                    <p>Let's discuss how we can help you attract more clients and build your legal practice online.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Legal;
